export default __webpack_public_path__ + "img/bg_sync_companies-eef6c07d4cdfba42b93b84bf51f5609d.png";